import { render, staticRenderFns } from "./ln-custom-button.vue?vue&type=template&id=5c59da13&"
import script from "./ln-custom-button.vue?vue&type=script&lang=js&"
export * from "./ln-custom-button.vue?vue&type=script&lang=js&"
import style0 from "./ln-custom-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/usr/src/app/components/icons/spinner.vue').default})
